/* ui/DocumentationPage.svelte generated by Svelte v3.23.2 */
import {
	SvelteComponent,
	append,
	attr,
	detach,
	element,
	init,
	insert,
	noop,
	safe_not_equal,
	space
} from "svelte/internal";

function add_css() {
	var style = element("style");
	style.id = "svelte-rzj8dg-style";
	style.textContent = "div.svelte-rzj8dg{margin:5px}pre.svelte-rzj8dg{font-family:Menlo, Monaco, 'Courier New', monospace}a.svelte-rzj8dg:link{color:inherit}a.svelte-rzj8dg:active{color:inherit}a.svelte-rzj8dg:visited{color:inherit}a.svelte-rzj8dg:hover{color:inherit}";
	append(document.head, style);
}

function create_fragment(ctx) {
	let div;
	let h10;
	let t1;
	let ul0;
	let t9;
	let h11;
	let t11;
	let p0;
	let t13;
	let p1;
	let t15;
	let p2;
	let t17;
	let h12;
	let t19;
	let h20;
	let t21;
	let p3;
	let t23;
	let ul1;
	let t31;
	let h21;
	let t33;
	let p4;
	let t35;
	let h30;
	let t37;
	let p5;
	let t39;
	let pre0;
	let t41;
	let h31;
	let t43;
	let p6;
	let t45;
	let pre1;
	let t47;
	let p7;
	let t49;
	let h32;
	let t51;
	let p8;
	let t53;
	let pre2;
	let t55;
	let p9;
	let t57;
	let pre3;
	let t59;
	let p10;
	let t61;
	let h22;
	let t63;
	let p11;
	let t65;
	let pre4;
	let t67;
	let p12;
	let t69;
	let h13;
	let t71;
	let p13;
	let t73;
	let h33;
	let t75;
	let p14;
	let t77;
	let pre5;
	let t79;
	let p15;
	let t81;
	let h34;
	let t83;
	let p16;
	let t85;
	let pre6;
	let t87;
	let p17;
	let t89;
	let h35;
	let t91;
	let p18;
	let t93;
	let pre7;
	let t95;
	let p19;
	let t97;
	let h36;
	let t99;
	let p20;
	let t101;
	let pre8;
	let t103;
	let p21;
	let t105;
	let h37;
	let t107;
	let p22;
	let t109;
	let pre9;
	let t111;
	let h14;
	let t113;
	let p23;
	let t115;
	let h38;
	let t117;
	let p24;
	let t119;
	let h39;
	let t121;
	let ul2;
	let t129;
	let h310;
	let t131;
	let ul3;
	let t135;
	let h311;
	let t137;
	let ul4;

	return {
		c() {
			div = element("div");
			h10 = element("h1");
			h10.textContent = "Table of Contents";
			t1 = space();
			ul0 = element("ul");

			ul0.innerHTML = `<li><a href="#Introduction" class="svelte-rzj8dg">Introduction</a></li> 
    <li><a href="#Mechanics" class="svelte-rzj8dg">Game Mechanics</a></li> 
    <li><a href="#Actions" class="svelte-rzj8dg">Actions</a></li> 
    <li><a href="#Configuration" class="svelte-rzj8dg">Configuration</a></li>`;

			t9 = space();
			h11 = element("h1");
			h11.innerHTML = `<a href="#Introduction" class="svelte-rzj8dg">Introduction</a>`;
			t11 = space();
			p0 = element("p");
			p0.textContent = "We made this game to allow us to write and test AI programs. Writers can use the example code to explore making their own AI. As a writer's code advances they should submit it to be tested against other AI. Eventually tournaments will be run between all submissions.";
			t13 = space();
			p1 = element("p");
			p1.textContent = "The game starts with a randomly generated map. Every turn all slimes take a single action, determined by each AI. The game runs for 1000 turns or until one team loses all of its slimes. At the end of the game the team with the highest score wins.";
			t15 = space();
			p2 = element("p");
			p2.textContent = "The current game is still being balanced and many of the parameters will likely be changed. Changes will be made in an attempt to balance the system but not destroy certain strategies. If someone figures out a way to win no matter what, through complex AI or an out of the box strategy then good for them.";
			t17 = space();
			h12 = element("h1");
			h12.innerHTML = `<a href="#Mechanics" class="svelte-rzj8dg">Game Mechanics</a>`;
			t19 = space();
			h20 = element("h2");
			h20.innerHTML = `<a href="#Turn Order" class="svelte-rzj8dg">Turn Order</a>`;
			t21 = space();
			p3 = element("p");
			p3.textContent = "Player AIs control each individual slime from their team every turn. Each game piece takes one action per turn.";
			t23 = space();
			ul1 = element("ul");

			ul1.innerHTML = `<li>Rocks go first and do nothing.</li> 
    <li>Plants go second and follow the steps outlined in <a href="#Game Pieces" class="svelte-rzj8dg">Game Pieces</a>.</li> 
    <li>Slimes alternate between each team until all slimes have gone.</li>`;

			t31 = space();
			h21 = element("h2");
			h21.innerHTML = `<a href="#Game Pieces" class="svelte-rzj8dg">Game Pieces</a>`;
			t33 = space();
			p4 = element("p");
			p4.textContent = "There are three types of game piece in this game.";
			t35 = space();
			h30 = element("h3");
			h30.innerHTML = `<a href="#Rocks" class="svelte-rzj8dg">Rocks</a>`;
			t37 = space();
			p5 = element("p");
			p5.textContent = "Rocks are only meant to get in the way. They do not move. All rocks have the following attirubtes:";
			t39 = space();
			pre0 = element("pre");

			pre0.textContent = `${`
  {
    id 1, // unique identifier for this game piece
    x: 0, // column the game piece is in
    y: 0, // row the game piece is in
    type: 'ROCK',
    owner: -1, // owner of this game piece. -1 is reserved for rocks and plants, 1 is player one and 2 is player two
    hp: 90, // current health points. If 0 the game piece dies
    maxHp: 100 // max health this game piece can have at its current level
  }
  `}`;

			t41 = space();
			h31 = element("h3");
			h31.innerHTML = `<a href="#Plants" class="svelte-rzj8dg">Plants</a>`;
			t43 = space();
			p6 = element("p");
			p6.textContent = "Plants are the food source for the slimes. All plants have the following attributes:";
			t45 = space();
			pre1 = element("pre");

			pre1.textContent = `${`
  {
    id 1, // unique identifier for this game piece
    x: 0, // column the game piece is in
    y: 0, // row the game piece is in
    type: 'PLANT',
    owner: -1, // owner of this game piece. -1 is reserved for rocks and plants, 1 is player one and 2 is player two
    hp: 20, // current health points. If 0 the game piece dies
    level: 4, // used to calculate the attack and maximum health of the slime
    maxLevel: 12, // max level this game piece can reach
    maxHp: 23 // max health this game piece can have at its current level
  }
  `}`;

			t47 = space();
			p7 = element("p");
			p7.textContent = "Plants are placed at the beginning of the game at level 1 with a set amount of hp. Every round the plant has a % chance to level up, which increases maxHp and regains some lost hp. Once a plant reaches its maxLevel it will gain the ability to spread seeds. Every round a max level plant has a % chance to spread a seed to one of the 8 squares surrounding it. Successful seeding plants a new level 1 plant in the target square. Plants at maximum level will change color.";
			t49 = space();
			h32 = element("h3");
			h32.innerHTML = `<a href="#Slimes" class="svelte-rzj8dg">Slimes</a>`;
			t51 = space();
			p8 = element("p");
			p8.textContent = "Slimes are the game pieces controlled by the submitted AI code and will be used to determine which AI wins a game. Each slime has the following attributes:";
			t53 = space();
			pre2 = element("pre");

			pre2.textContent = `${`
  {
    id 1, // unique identifier for this game piece
    x: 0, // column the game piece is in
    y: 0, // row the game piece is in
    type: 'SLIME',
    owner: 1, // owner of this game piece. -1 is reserved for rocks and plants, 1 is player one and 2 is player two
    xp: 23, // current experience. Used to calculate level
    hp: 20, // current health points. If 0 the game piece dies
    level: 4, // used to calculate the attack and maximum health of the slime
    maxLevel: 12, // max level this game piece can reach
    maxHp: 23, // max health this game piece can have at its current level
    attack: 10, // amount of health an opponent loses when this slime bites it
  }
  `}`;

			t55 = space();
			p9 = element("p");
			p9.textContent = "Slimes are placed at the beginning of the game at level 1. A slime's attack and maxHp increase as they level up. The table below shows the minimum xp for a slime to become each level and the other attributes for that level.";
			t57 = space();
			pre3 = element("pre");
			pre3.textContent = "xp\tlevel\tattack\tmaxHp\n1\t1\t3\t11\n2\t2\t4\t13\n6\t3\t7\t18\n15\t4\t10\t23\n33\t5\t13\t31\n62\t6\t16\t40\n106\t7\t20\t50\n169\t8\t24\t61\n254\t9\t29\t75\n368\t10\t33\t89\n513\t11\t38\t105\n695\t12\t43\t122";
			t59 = space();
			p10 = element("p");
			p10.textContent = "Every turn each slime is given a round to take a single action determined by the submitted AI. Invalid actions and exceptions are ignored, skipping that slime's round. Valid actions are applied immediately, before the next slime's round begins. Note that the game state given to the AI is immutable, so changes are not reflected in the game engine.";
			t61 = space();
			h22 = element("h2");
			h22.innerHTML = `<a href="#Victory" class="svelte-rzj8dg">Victory Conditions</a>`;
			t63 = space();
			p11 = element("p");
			p11.textContent = "The game will continue until turn 1000 or until one team has 0 slimes. Scores for each team are calculated based on the remaining slimes. This score calculation is based solely on the slimes level not on its total xp. The table below shows a simplified level to score ratio.";
			t65 = space();
			pre4 = element("pre");
			pre4.textContent = "level\tpoints\n1\t0.2\n2\t0.4\n3\t1.6\n4\t5.2\n5\t13.7\n6\t29.9\n7\t57.7\n8\t101.7\n9\t167.0\n10\t259.7\n11\t386.7\n12\t555.3";
			t67 = space();
			p12 = element("p");
			p12.textContent = "The team with the most total points at the end of the game wins.";
			t69 = space();
			h13 = element("h1");
			h13.innerHTML = `<a href="#Actions" class="svelte-rzj8dg">Actions</a>`;
			t71 = space();
			p13 = element("p");
			p13.textContent = "A Slime can take one of 5 actions each turn: MOVE, BITE, SPLIT, MERGE, or NOTHING.";
			t73 = space();
			h33 = element("h3");
			h33.innerHTML = `<a href="#Move" class="svelte-rzj8dg">Move</a>`;
			t75 = space();
			p14 = element("p");
			p14.textContent = "Move the slime to a nearby cell.";
			t77 = space();
			pre5 = element("pre");

			pre5.textContent = `${`
  {
    action: 'MOVE',
    x: 1,
    y: 2
  }
  `}`;

			t79 = space();
			p15 = element("p");
			p15.textContent = "If the target cell is occupied by another game piece or if the cell is outside of the movement range of the slime then the slime does nothing for its round. A slime can only move a distance of one cell in a cardinal direction (UP, DOWN, LEFT, RIGHT).";
			t81 = space();
			h34 = element("h3");
			h34.innerHTML = `<a href="#Bite" class="svelte-rzj8dg">Bite</a>`;
			t83 = space();
			p16 = element("p");
			p16.textContent = "Bite a nearby cell.";
			t85 = space();
			pre6 = element("pre");

			pre6.textContent = `${`
  {
    action: 'BITE',
    x: 1,
    y: 2
  }
  `}`;

			t87 = space();
			p17 = element("p");
			p17.textContent = "If there is not a valid game piece in the target cell or if the target cell is outside the slime's attack range then the slime will do nothing for its round. If there is a game piece in the target cell then that game piece will have its hp reduced by the biting slime's attack. If the target was valie the slime gains 1 xp and 1 hp. A slime can only bite a distance of one cell in a cardinal direction (UP, DOWN, LEFT, RIGHT).";
			t89 = space();
			h35 = element("h3");
			h35.innerHTML = `<a href="#Split" class="svelte-rzj8dg">Split</a>`;
			t91 = space();
			p18 = element("p");
			p18.textContent = "Sacrifice xp to split this slime into two.";
			t93 = space();
			pre7 = element("pre");

			pre7.textContent = `${`
  {
    action: 'SPLIT'
  }
  `}`;

			t95 = space();
			p19 = element("p");
			p19.textContent = "To split a slime must be at or above the \"Min Level to Split\" defined in the game settings. Splitting creates a new slime in a random empty adjacent square. The xp of the original slime is divided by 4 (rounding down) and given to each slime. Both slimes will have one quarter of the original slimes xp and retain the same percentage of health.";
			t97 = space();
			h36 = element("h3");
			h36.innerHTML = `<a href="#Merge" class="svelte-rzj8dg">Merge</a>`;
			t99 = space();
			p20 = element("p");
			p20.textContent = "Merge two slimes together into one more powerful slime.";
			t101 = space();
			pre8 = element("pre");

			pre8.textContent = `${`
  {
    action: 'MERGE'
  }
  `}`;

			t103 = space();
			p21 = element("p");
			p21.textContent = "This sets a slime as ready to merge. If an adjacent friendly slime is ready to merge it will be destroyed and the initiating slime will gain its xp. At the end of each turn all slimes are set to no longer ready to merge, so you must coordinate merging within a single turn.";
			t105 = space();
			h37 = element("h3");
			h37.innerHTML = `<a href="#Nothing" class="svelte-rzj8dg">Nothing</a>`;
			t107 = space();
			p22 = element("p");
			p22.textContent = "A slime can skip its round by taking the NOTHING action.";
			t109 = space();
			pre9 = element("pre");

			pre9.textContent = `${`
  {
    action: 'NOTHING'
  }
  `}`;

			t111 = space();
			h14 = element("h1");
			h14.innerHTML = `<a href="#Configuration" class="svelte-rzj8dg">Game Configuration</a>`;
			t113 = space();
			p23 = element("p");
			p23.textContent = "On the Game Tab, in the far left column the following settings can be changed between each match.";
			t115 = space();
			h38 = element("h3");
			h38.innerHTML = `<a href="#Player AIs" class="svelte-rzj8dg">Player AIs</a>`;
			t117 = space();
			p24 = element("p");
			p24.textContent = "You can select the AI for player one (red) and player two (blue). The AI you write in the code tab will be included in this list, along with some AI from the game's creators.";
			t119 = space();
			h39 = element("h3");
			h39.innerHTML = `<a href="#Plant Configuration" class="svelte-rzj8dg">Plant Configuration</a>`;
			t121 = space();
			ul2 = element("ul");

			ul2.innerHTML = `<li>Initial plants: This will determine the number of plants to be placed before the beginning of the match. (These plants are placed randomly with a maximum of 10k attempts).</li> 
    <li>Chance to Seed(%): Once a plant has reached max level it will have a chance each turn to randomly place a level 1 plant in one of the adjacent cells. The chance for a plant to successfully seed an empty adjacent cell is set here.</li> 
    <li>Chance to Level(%): Each turn a plant that is lower than the maximum plant level will have a chance to level up 1 level. The percent chance for a plant to level up is set here.</li> 
    <li>Max Level: This is the maximum level a plant can reach. Once a plant has reached its maximum level it has a chance to seed near by cells each turn. The higher the maximum level the slower the plants will spread but the stronger the plants will become.</li>`;

			t129 = space();
			h310 = element("h3");
			h310.innerHTML = `<a href="#Slime Configuration" class="svelte-rzj8dg">Slime Configuration</a>`;
			t131 = space();
			ul3 = element("ul");

			ul3.innerHTML = `<li>Initial Slimes: This will determine the number of slimes to be placed before the beginning of the match on each edge of the map. (These slimes are placed randomly on one of the far sides of the map, then an opponent slime is mirrored to the other side).</li> 
    <li>Min Level to Split: This will set the minimum level that a slime will be allowed to split. (A good AI will use this configuration setting for its split actions instead of hard coded values).</li>`;

			t135 = space();
			h311 = element("h3");
			h311.innerHTML = `<a href="#Rock Configuration" class="svelte-rzj8dg">Rock Configuration</a>`;
			t137 = space();
			ul4 = element("ul");

			ul4.innerHTML = `<li>Initial Rocks: This will determine the number of rocks to be placed before the beginning of the match. (These rocks are placed randomly with a maximum of 10k attempts).</li> 
    <li>Max HP: This will set the maximum HP of rocks. (This setting will likely be hard coded above 150 hp at some point).</li>`;

			attr(h11, "id", "Introduction");
			attr(h12, "id", "Mechanics");
			attr(h20, "id", "Turn Order");
			attr(h21, "id", "Game Pieces");
			attr(h30, "id", "Rocks");
			attr(pre0, "class", "svelte-rzj8dg");
			attr(h31, "id", "Plants");
			attr(pre1, "class", "svelte-rzj8dg");
			attr(h32, "id", "Slimes");
			attr(pre2, "class", "svelte-rzj8dg");
			attr(pre3, "class", "svelte-rzj8dg");
			attr(h22, "id", "Victory");
			attr(pre4, "class", "svelte-rzj8dg");
			attr(h13, "id", "Actions");
			attr(h33, "id", "Move");
			attr(pre5, "class", "svelte-rzj8dg");
			attr(h34, "id", "Bite");
			attr(pre6, "class", "svelte-rzj8dg");
			attr(h35, "id", "Split");
			attr(pre7, "class", "svelte-rzj8dg");
			attr(h36, "id", "Merge");
			attr(pre8, "class", "svelte-rzj8dg");
			attr(h37, "id", "Nothing");
			attr(pre9, "class", "svelte-rzj8dg");
			attr(h14, "id", "Configuration");
			attr(h38, "id", "Player AIs");
			attr(h39, "id", "Plant Configuration");
			attr(h310, "id", "Slime Configuration");
			attr(h311, "id", "Rock Configuration");
			attr(div, "class", "svelte-rzj8dg");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			append(div, h10);
			append(div, t1);
			append(div, ul0);
			append(div, t9);
			append(div, h11);
			append(div, t11);
			append(div, p0);
			append(div, t13);
			append(div, p1);
			append(div, t15);
			append(div, p2);
			append(div, t17);
			append(div, h12);
			append(div, t19);
			append(div, h20);
			append(div, t21);
			append(div, p3);
			append(div, t23);
			append(div, ul1);
			append(div, t31);
			append(div, h21);
			append(div, t33);
			append(div, p4);
			append(div, t35);
			append(div, h30);
			append(div, t37);
			append(div, p5);
			append(div, t39);
			append(div, pre0);
			append(div, t41);
			append(div, h31);
			append(div, t43);
			append(div, p6);
			append(div, t45);
			append(div, pre1);
			append(div, t47);
			append(div, p7);
			append(div, t49);
			append(div, h32);
			append(div, t51);
			append(div, p8);
			append(div, t53);
			append(div, pre2);
			append(div, t55);
			append(div, p9);
			append(div, t57);
			append(div, pre3);
			append(div, t59);
			append(div, p10);
			append(div, t61);
			append(div, h22);
			append(div, t63);
			append(div, p11);
			append(div, t65);
			append(div, pre4);
			append(div, t67);
			append(div, p12);
			append(div, t69);
			append(div, h13);
			append(div, t71);
			append(div, p13);
			append(div, t73);
			append(div, h33);
			append(div, t75);
			append(div, p14);
			append(div, t77);
			append(div, pre5);
			append(div, t79);
			append(div, p15);
			append(div, t81);
			append(div, h34);
			append(div, t83);
			append(div, p16);
			append(div, t85);
			append(div, pre6);
			append(div, t87);
			append(div, p17);
			append(div, t89);
			append(div, h35);
			append(div, t91);
			append(div, p18);
			append(div, t93);
			append(div, pre7);
			append(div, t95);
			append(div, p19);
			append(div, t97);
			append(div, h36);
			append(div, t99);
			append(div, p20);
			append(div, t101);
			append(div, pre8);
			append(div, t103);
			append(div, p21);
			append(div, t105);
			append(div, h37);
			append(div, t107);
			append(div, p22);
			append(div, t109);
			append(div, pre9);
			append(div, t111);
			append(div, h14);
			append(div, t113);
			append(div, p23);
			append(div, t115);
			append(div, h38);
			append(div, t117);
			append(div, p24);
			append(div, t119);
			append(div, h39);
			append(div, t121);
			append(div, ul2);
			append(div, t129);
			append(div, h310);
			append(div, t131);
			append(div, ul3);
			append(div, t135);
			append(div, h311);
			append(div, t137);
			append(div, ul4);
		},
		p: noop,
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(div);
		}
	};
}

class DocumentationPage extends SvelteComponent {
	constructor(options) {
		super();
		if (!document.getElementById("svelte-rzj8dg-style")) add_css();
		init(this, options, null, create_fragment, safe_not_equal, {});
	}
}

export default DocumentationPage;